<template>
    <div class="card">
        <header class="card-header">
            <p class="card-header-title">
                Profit
            </p>
        </header>
        <div class="card-content">
            <div class="content">
                <h1>{{ profit | formatNumber }}</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            profit() {
                return this.$store.getters.getProfitSectionData.total_profit
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitTotalProfit.vue